import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from './http-client.service';

@Injectable()
export class AppSettingsService {
  public apiUrl = 'app-settings';

  constructor(private readonly http: HttpClientService) {}

  public getUserWayStatus(): Observable<{ EnableUserWay: boolean }> {
    return this.http.get(`${this.apiUrl}/get-userway-status`);
  }
}
